import engineUserAgent from './engine-user-agent.js';
import global$1 from './global.js';

var userAgent = engineUserAgent;
var global = global$1;
var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;

export { engineIsIosPebble as default };
